import { useMutation } from "react-query";

import { IdDnmRoleMappingIProps } from "~/entity/DnmRoleMappings/model/schema";

import { useDnmRoleMappings } from "./useDnmRoleMappings";

interface MutateOptions {
  onSuccess?: () => void;
  onError?: (error: any) => void;
}

interface DataIProps {
  data: IdDnmRoleMappingIProps;
  options?: MutateOptions;
}

export const useDeleteDnmRoleMapping = () => {
  const { deleteRoleMapping } = useDnmRoleMappings();
  const mutation = useMutation({
    mutationFn: async (props: DataIProps) => {
      await deleteRoleMapping(props.data.id);
    },
    onSuccess: (data, { options }) => {
      options?.onSuccess?.();
    },
    onError: (error, { options }) => {
      options?.onError?.(error);
    },
  });
  const remove = (data: IdDnmRoleMappingIProps, options?: MutateOptions) => {
    mutation.mutate({ data, options });
  };
  return { remove };
};
